import { Box } from '@chakra-ui/react'
import SidBarInfo from './SideBarInfo'
import PatientHistory from './PatientHistory'
import { Outlet, useLocation, useOutletContext } from 'react-router-dom'
import { useState } from 'react'
import { ISharedDiagnostic } from '../../../types/diagnostics'

type ContextType = {
  setDiagnosticData: (data: ISharedDiagnostic) => void
}

export default function PatientCard() {
  const location = useLocation()
  const isWhiteboardView = location.pathname.includes('/diagnostics/')
  const [diagnosticData, setDiagnosticData] =
    useState<ISharedDiagnostic | null>(null)

  return (
    <Box display={'flex'} h={'100%'} w={'100%'} bg="gray.50">
      <Box w={'28%'} borderRight="1px solid" borderColor="gray.200">
        <SidBarInfo diagnosticData={isWhiteboardView ? diagnosticData : null} />
      </Box>
      <Box w={'72%'}>
        {isWhiteboardView ? (
          <Outlet context={{ setDiagnosticData } as ContextType} />
        ) : (
          <PatientHistory />
        )}
      </Box>
    </Box>
  )
}

export function useDiagnosticContext() {
  return useOutletContext<ContextType>()
}
